import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const context = '.page-template-template-home section:not(.hero)';


if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let textHomeArray = gsap.utils.toArray([`${context} h2`, `${context} h3`, `${context} h4`, `${context} h5`, `${context} h6`, `${context} p`, `${context}#home1 button`, `${context}#home3 button`,`${context}#home1 img`]);
    let imgArray = gsap.utils.toArray([`${context}#home3 .image img`]);


    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;

    
        textHomeArray.forEach(text => {
            let textHomeTl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: 'top bottom-=200',
                    end: 'bottom top',
                    once: true,
                }
            });
            textHomeTl.from(text, {opacity: 0, duration: 1, y: 20});
        });

        imgArray.forEach(img => {
            let imgHomeTl = gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: 'top bottom-=200',
                    end: 'bottom top',
                    once: true,
                }
            });
            imgHomeTl.from(img, {scale: 1.2, duration: 1, y: 20});
        });

    });

}